import React from "react";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";

const Breadcrumb = ({
  title = "Dịch Vụ",
  parent = null, // { name, path }
  parent2 = null, // cấp 2 (nếu có)
}) => {
  // Gom các cấp cha hợp lệ vào mảng
  const items = [parent, parent2].filter(Boolean);

  return (
    <div
      className="breadcrumb-wrapper section-bg bg-cover"
      style={{ backgroundImage: "url('/assets/img/breadcrumb-shape.png')" }}
    >
      {/* Decorative shapes */}
      <div className="arrow-shape">
        <img
          src="/assets/img/arrow-shape.png"
          alt="arrow shape"
        />
      </div>
      <div className="circle-shape">
        <img
          src="/assets/img/circle-shape.png"
          alt="circle shape"
        />
      </div>

      {/* Title & breadcrumb */}
      <div className="container">
        <div className="page-heading">
          <div className="breadcrumb-sub-title">
            <h1
              className="wow fadeInUp"
              data-wow-delay=".3s"
            >
              {title.toUpperCase()}
            </h1>
          </div>
          <ul
            className="breadcrumb-items wow fadeInUp"
            data-wow-delay=".5s"
          >
            {items.map((item, i) => (
              <React.Fragment key={i}>
                <li>
                  {item.path ? (
                    <Link to={item.path}>{item.name}</Link>
                  ) : (
                    <span>{item.name}</span>
                  )}
                </li>
                <li>
                  <FaChevronRight />
                </li>
              </React.Fragment>
            ))}
            <li>{title}</li>
          </ul>
        </div>
      </div>

      {/* Marquee scrolling text */}
      <div className="marquee-section fix">
        <div className="mycustom-marque">
          <div className="scrolling-wrap">
            {[...Array(3)].map((_, i) => (
              <div
                className="comm"
                key={i}
              >
                <div className="cmn-textslide textitalick text-custom-storke">
                  {title.toUpperCase()}
                </div>
                <div className="cmn-textslide textitalick">
                  {title.toUpperCase()}
                </div>
                <div className="cmn-textslide textitalick text-custom-storke">
                  {title.toUpperCase()}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
